import script from "./SectionFaq.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionFaq.vue?vue&type=script&setup=true&lang=js"

import "./SectionFaq.vue?vue&type=style&index=0&id=33e4effa&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33e4effa"]])

export default __exports__